import { stripAllSpaces } from "utils/helpers/validations";
import { validateNIR } from "utils/helpers/values";
import * as yup from "yup";

const validation = (messages) => {
  return yup.object().shape({
    socialSecurityNumber: yup
      .string()
      .transform(stripAllSpaces)
      .typeError(messages.REQUIRED)
      .required(messages.REQUIRED)
      .test(
        "validateNIR",
        messages.INVALID_SOCIAL_SECURITY_NUMBER,
        function (value, ctx) {
          const result = validateNIR(value, this.parent);
          if (!result.valid)
            return ctx.createError({
              message: messages[result.reason] || messages.INVALID_VALUE,
            });

          return true;
        },
      ),
  });
};

export default validation;
